'use client';
import {
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
} from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';

import { ErrorBoundary } from '@/components';
import { useT } from '@/hooks';

interface DateNavigationProps {
  onPrev: () => void;
  onNext: () => void;
  prevDisabled: boolean;
  nextDisabled: boolean;
  dateRange: string;
}

export const DateNavigation = ({
  onPrev,
  onNext,
  prevDisabled,
  nextDisabled,
  dateRange,
}: DateNavigationProps) => {
  const { t } = useT();
  return (
    <ErrorBoundary
      fallback={
        <Box p={2} color="error.main">
          {t('earnings.failedToLoadNavigation')}
        </Box>
      }
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 2,
          mb: 3,
        }}
      >
        <IconButton
          onClick={onPrev}
          disabled={prevDisabled}
          size="small"
          sx={{
            color: 'text.secondary',
            '&:disabled': {
              opacity: 0.5,
            },
          }}
        >
          <ChevronLeftIcon />
        </IconButton>
        <Typography
          sx={{
            fontSize: '0.875rem',
            fontWeight: 500,
            color: 'text.primary',
            minWidth: 120,
            textAlign: 'center',
          }}
        >
          {dateRange}
        </Typography>
        <IconButton
          onClick={onNext}
          disabled={nextDisabled}
          size="small"
          sx={{
            color: 'text.secondary',
            '&:disabled': {
              opacity: 0.5,
            },
          }}
        >
          <ChevronRightIcon />
        </IconButton>
      </Box>
    </ErrorBoundary>
  );
};
